<template>
  <main id="page" :class="className" v-if="document">
    <component v-for="(slice, index) of slices" :is="sliceToComponent(slice)" :key="`${className}-${index}`" :slice="slice" />
  </main>
</template>

<script>
  import SliceLoader from 'mixins/slice-loader';
  import TextSlice from 'components/slices/text';
  import ImageSlice from 'components/slices/image';
  import MenuSlice from 'components/slices/menu';
  import MenuGroupSlice from 'components/slices/menu-group';
  import EatInMenuGroupSlice from 'components/slices/eat-in-menu-group';

  export default {
    name: 'Page',
    components: { TextSlice, ImageSlice, MenuSlice, MenuGroupSlice, EatInMenuGroupSlice},
    mixins: [SliceLoader],

    computed: {
      location () {
        return this.$route.params.location || (this.$route.meta && this.$route.meta.location);
      },

      pageUid () {
        return this.$route.meta?.uid || this.$route.params.uid || 'index';
      },

      contentParams () {
        return { type: 'page', uid: this.pageUid };
      }
    },

    data () {
      return {
        document: null
      };
    },

    watch: {
      $route (to) {
        const uid = this.pageUid;
        const routeName = to.name;

        if (['page', 'index', 'enskede-landing', 'haga-norra-landing', 'slaktis-landing'].includes(routeName)) {
          this.loadByUID({ type: 'page', uid: uid });
        }
      },

      document (doc) {
        const { title } = doc;

        if (this.$route.name === 'index') {
          document.title = 'Ateljens Pizza';
          return;
        }

        if (title) {
          document.title = `${title} - Ateljens Pizza`;
        }
      }
    }
  };
</script>

<style lang="stylus">
  main
    padding: 2rem

  .enskede,
  .haga-norra,
  .slaktis
    text-transform: uppercase
    .text-container
      a
        text-decoration: none

      h1
        margin-bottom: 1.4rem
        text-transform: uppercase
        line-height: 1.3rem

      p
        margin: .5rem 0
        text-transform: uppercase

  p:empty::before
    content: "\00a0"
    visibility: hidden
</style>
